/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
import { SectionGroupV2, ConfigToggle } from 'material/expandablesection/v2'
import Space from 'material/space/space'
import Emoji from '../../sitethemesection/components/emoji/emoji'
import PreviewConfig from '../../previewconfig/previewconfig'
// styles
import injectSheet from 'react-jss'
import styles from './emoticoncommentreactions_styles'


/* ========== ~~~~~~~~~~ COMMENTING CONFIG V2: GENERAL SECTION : EMOTICON COMMENT REACTIONS ~~~~~~~~~~ ========== */
const EmoticonCommentReactions = injectSheet(styles)((props) => {

  const { allowReaction, onChange } = props 

  return (
    <SectionGroupV2 klass={`emoticoncommentreactions ${props.classes.emoticoncommentreactions}`} title={'Reactions'} description={'Select whether users can react to comments with emojis.'}>
      <ConfigToggle 
        title={'Allow reactions'}
        description={'Configure reaction availability and emoji styles in the "Theme" section.'}
        checked={allowReaction}
        onChange={val => onChange('allowReaction', val)}
      />
      <PreviewConfig disabled={!allowReaction}>
        <Space klass={'emojipreview'}>
          <Emoji name={'LIKE'} size={28} type={'THREE_D'} />
          <Emoji name={'DISLIKE'} size={28} type={'THREE_D'} />
          <Emoji name={'LOVE'} size={28} type={'THREE_D'} />
          <Emoji name={'FUNNY'} size={28} type={'THREE_D'} />
          <Emoji name={'SAD'} size={28} type={'THREE_D'} />
          <Emoji name={'ANGRY'} size={28} type={'THREE_D'} />
          <Emoji name={'SHOCKED'} size={28} type={'THREE_D'} />
          <Emoji name={'THOUGHTFUL'} size={28} type={'THREE_D'} />
        </Space>
      </PreviewConfig>
    </SectionGroupV2>
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default EmoticonCommentReactions;